import _ from 'underscore';

const SOVLostColumns = {
  TopImpressionShareLostToRank: 'TopISLostToRankPercent',
  TopImpressionShareLostToBudget: 'TopISLostToBudgetPercent',
  AbsoluteTopImpressionShareLostToRank: 'AbsoluteTopISLostToRankPercent',
  AbsoluteTopImpressionShareLostToBudget: 'AbsoluteTopISLostToBudgetPercent',
};

export default _.mapObject(SOVLostColumns, property => `PerformanceMetrics/${property}`);
